// Escopo GLOBAL dos jogos

export default {
  data() {
    return {
      tabs: [
        {
          title: "Dados Cadastrais",
          class: "dadosCad",
        },
        {
          title: "Comissao e Antecipação",
          class: "comAnt",
        },
        {
          title: "Dados Bancários",
          class: "dadosBanc",
        },
        {
          title: "Documentos",
          class: "docs",
        },
        {
          title: "Contratos",
          class: "contr",
        },
      ],
      headers: [
        {
          title: "Sequência",
        },
        {
          title: "Nome do Agente",
        },
        {
          title: "CPF/CNPJ",
        },
        {
          title: "Data Cadastro",
        },
        {
          title: "Status",
        },
        {
          title: "Ações",
        },
      ],
      tipo_pessoa: ["JURÍDICA", "FISÍCA"],
    };
  },

  methods: {
    pdvTab(tab) {
      switch (tab.title) {
        case "Dados Cadastrais":
          document.getElementsByClassName(
            "pessoas-agentes-dados-cadastrais"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-agentes-comissao-antecipacao"
          )[0].style.display = "none";
          document.getElementsByClassName("comAnt")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("comAnt")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-dados-bancarios"
          )[0].style.display = "none";
          document.getElementsByClassName(
            "dadosBanc"
          )[0].style.backgroundColor = "#c9c9c9";
          document.getElementsByClassName("dadosBanc")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-documentos"
          )[0].style.display = "none";
          document.getElementsByClassName("docs")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("docs")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-contratos"
          )[0].style.display = "none";
          document.getElementsByClassName("contr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("contr")[0].style.color = "#000";
          break;

        case "Comissao e Antecipação":
          document.getElementsByClassName(
            "pessoas-agentes-comissao-antecipacao"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-agentes-dados-cadastrais"
          )[0].style.display = "none";
          document.getElementsByClassName("dadosCad")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("dadosCad")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-dados-bancarios"
          )[0].style.display = "none";
          document.getElementsByClassName(
            "dadosBanc"
          )[0].style.backgroundColor = "#c9c9c9";
          document.getElementsByClassName("dadosBanc")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-documentos"
          )[0].style.display = "none";
          document.getElementsByClassName("docs")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("docs")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-contratos"
          )[0].style.display = "none";
          document.getElementsByClassName("contr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("contr")[0].style.color = "#000";
          break;

        case "Dados Bancários":
          document.getElementsByClassName(
            "pessoas-agentes-dados-bancarios"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-agentes-dados-cadastrais"
          )[0].style.display = "none";
          document.getElementsByClassName("dadosCad")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("dadosCad")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-comissao-antecipacao"
          )[0].style.display = "none";
          document.getElementsByClassName("comAnt")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("comAnt")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-documentos"
          )[0].style.display = "none";
          document.getElementsByClassName("docs")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("docs")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-contratos"
          )[0].style.display = "none";
          document.getElementsByClassName("contr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("contr")[0].style.color = "#000";
          break;

        case "Documentos":
          document.getElementsByClassName(
            "pessoas-agentes-documentos"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-agentes-dados-bancarios"
          )[0].style.display = "none";
          document.getElementsByClassName(
            "dadosBanc"
          )[0].style.backgroundColor = "#c9c9c9";
          document.getElementsByClassName("dadosBanc")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-dados-cadastrais"
          )[0].style.display = "none";
          document.getElementsByClassName("dadosCad")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("dadosCad")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-comissao-antecipacao"
          )[0].style.display = "none";
          document.getElementsByClassName("comAnt")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("comAnt")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-contratos"
          )[0].style.display = "none";
          document.getElementsByClassName("contr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("contr")[0].style.color = "#000";
          break;

        case "Contratos":
          document.getElementsByClassName(
            "pessoas-agentes-contratos"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-agentes-dados-bancarios"
          )[0].style.display = "none";
          document.getElementsByClassName(
            "dadosBanc"
          )[0].style.backgroundColor = "#c9c9c9";
          document.getElementsByClassName("dadosBanc")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-dados-cadastrais"
          )[0].style.display = "none";
          document.getElementsByClassName("dadosCad")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("dadosCad")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-comissao-antecipacao"
          )[0].style.display = "none";
          document.getElementsByClassName("comAnt")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("comAnt")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-documentos"
          )[0].style.display = "none";
          document.getElementsByClassName("docs")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("docs")[0].style.color = "#000";
          break;

        default:
          document.getElementsByClassName(
            "pessoas-agentes-dados-cadastrais"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-agentes-comissao-antecipacao"
          )[0].style.display = "none";
          document.getElementsByClassName("comAnt")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("comAnt")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-dados-bancarios"
          )[0].style.display = "none";
          document.getElementsByClassName(
            "dadosBanc"
          )[0].style.backgroundColor = "#c9c9c9";
          document.getElementsByClassName("dadosBanc")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-documentos"
          )[0].style.display = "none";
          document.getElementsByClassName("docs")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("docs")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-agentes-contratos"
          )[0].style.display = "none";
          document.getElementsByClassName("contr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("contr")[0].style.color = "#000";
          break;
      }
    },
    goToAgente(type, data) {
      this.$pessoas_agentes.agentesAddEdit = type;

      if (type === "edit") {
        this.$axios.rota("/pessoas/agentes/editar");
        this.$pessoas_agentes.cadastro.idagente = data.idagente;

        // DADOS CADASTRAIS
        this.$pessoas_agentes.cadastro.dados_cadastrais.razao_social =
          data.razao_social;
        (this.$pessoas_agentes.cadastro.dados_cadastrais.cnpj = data.cnpj),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.nome_representante =
            data.representante_nome),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.cpf =
            data.representante_cpf),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.rg =
            data.representante_rg),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.rg_orgao =
            data.representante_rg_orgao),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.email =
            data.representante_email),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.celular =
            data.celular),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.regional =
            data.nidregional),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.cep = data.end_cep),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.estado =
            data.end_estado),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.cidade =
            data.end_cidade),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.bairro =
            data.end_bairro),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.logradouro =
            data.end_logradouro),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.complemento =
            data.end_complemento),
          (this.$pessoas_agentes.cadastro.dados_cadastrais.status =
            data.status),
          (this.$pessoas_agentes.cadastro.comissao_antecipacao.comissao =
            data.comissao),
          (this.$pessoas_agentes.cadastro.comissao_antecipacao.porcentagem_web =
            data.porcentagem_web),
          (this.$pessoas_agentes.cadastro.comissao_antecipacao.porcentagem_rede =
            data.porcentagem_rede),
          (this.$pessoas_agentes.cadastro.comissao_antecipacao.antecipacao =
            data.antecipacao),
          (this.$pessoas_agentes.cadastro.comissao_antecipacao.taxa_personalizada =
            data.taxa_personalizada),
          (this.$pessoas_agentes.cadastro.comissao_antecipacao.dias_antecipacao =
            data.dias_antecipacao),
          (this.$pessoas_agentes.cadastro.comissao_antecipacao.taxa_mes =
            data.taxa_mes),
          (this.$pessoas_agentes.cadastro.comissao_antecipacao.observacoes =
            data.observacoes),
          // dados bancarios
          (this.$pessoas_agentes.cadastro.dados_bancarios.nome_titular =
            data.nome_titular),
          (this.$pessoas_agentes.cadastro.dados_bancarios.banco = data.banco),
          (this.$pessoas_agentes.cadastro.dados_bancarios.agencia =
            data.agencia),
          (this.$pessoas_agentes.cadastro.dados_bancarios.tipo_de_conta =
            data.tipo_de_conta),
          (this.$pessoas_agentes.cadastro.dados_bancarios.nome_titular =
            data.nome_titular),
          (this.$pessoas_agentes.cadastro.dados_bancarios.numero_conta =
            data.numero_conta),
          (this.$pessoas_agentes.cadastro.dados_bancarios.digito = data.digito),
          // documentos
          (this.$pessoas_agentes.cadastro.documentos.contrato_social =
            data.contrato_social),
          (this.$pessoas_agentes.cadastro.documentos.comprovante_endereco =
            data.comprovante_endereco),
          (this.$pessoas_agentes.cadastro.documentos.procuracao =
            data.procuracao),
          // contratos
          (this.$pessoas_agentes.cadastro.contratos.template = data.template);
        return;
      }

      this.$axios.rota("/pessoas/agentes/cadastrar");
    },
  },
};
